import { Grid } from 'antd';

const { useBreakpoint } = Grid;

// breakpoint value = xs|sm|md|lg|xl
export const useAppBreakpoint = (breakpoint) => {
    const screens = useBreakpoint();

    return !!screens[breakpoint];
}